import { useMemo } from "react";

import { Observation } from "@medplum/fhirtypes";

import { Table } from "@mantine/core";

import { TextWrapper } from "@/components/TextWrapper";
import PostpartumTimeCell from "@/encounters/components/EncounterLabor/EncounterLaborPostpartum/PostpartumTable/PostpartumTimeCell";
import LastUpdated from "@/encounters/components/EncounterLabor/EncounterLaborTable/LaborRow/Common/LastUpdated";
import PreviousVersions from "@/encounters/components/EncounterLabor/EncounterLaborTable/LaborRow/Common/PreviousVersions";
import classes from "@/encounters/components/EncounterLabor/EncounterLaborTable/LaborRow/Common/PreviousVersions.module.css";
import { hasPreviousVersions } from "@/encounters/components/EncounterLabor/services/labor";
import { getCordClampedRowValues } from "@/encounters/components/EncounterLabor/utils/postpartum";

interface NewbornCordClampedRowProps {
  time: string;
  observation?: Observation;
  showNumbersOnly?: boolean;
  isViewOnly: boolean;
  showPreviousVersions?: boolean;
  onRefresh?: () => Promise<void>;
}

export default function NewbornCordClampedRow({
  time,
  observation,
  showNumbersOnly,
  isViewOnly,
  showPreviousVersions = true,
  onRefresh,
}: NewbornCordClampedRowProps) {
  const { notes, hasNotes } = useMemo(() => getCordClampedRowValues(observation), [observation]);

  if (!observation) return null;

  const previousVersions = hasPreviousVersions(observation);

  if (showNumbersOnly) return null;

  return (
    <Table.Tr bg="white" className={classes.tableRow}>
      {showPreviousVersions && (
        <PostpartumTimeCell
          time={time}
          rowSpan={1}
          onRefresh={onRefresh}
          isViewOnly={isViewOnly}
          observation={observation}
        />
      )}
      <Table.Td p="md" colSpan={10}>
        <TextWrapper size="sm" variant="bold">
          Cord Cut/Clamped
        </TextWrapper>
        {hasNotes && <TextWrapper size="sm">Comments: {notes}</TextWrapper>}
        {showPreviousVersions && previousVersions ? (
          <PreviousVersions
            observation={observation}
            rowComponent={NewbornCordClampedRow}
            showPreviousVersions={showPreviousVersions}
          />
        ) : (
          <LastUpdated observation={observation} showPreviousVersions={false} />
        )}
      </Table.Td>
    </Table.Tr>
  );
}
